export default __webpack_public_path__ + "static/product-bar-bisolduo-surup-0891c1f182e2ab3eae7cb8ed2b363a9b.png";